import { Outlet } from "react-router-dom";
import BroadcastList from "./BroadcastList";
import BroadcastForm from "./BroadcastForm";

export const adminBroadcastRoutes = [
  {
    path: "broadcasts",
    element: Outlet,
    children: [
      {
        path: "",
        element: BroadcastList,
      },
      {
        path: "add",
        element: BroadcastForm,
      },
      {
        path: "edit/:id",
        element: BroadcastForm,
      },
    ],
  },
];
